import { View, styled } from "tamagui";

export const VisuallyHidden = styled(View, {
  name: "VisuallyHidden",
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  // @ts-expect-error — web-only CSS property, RN-Web passes through
  whiteSpace: "nowrap",
  borderWidth: 0,
});
